export const PICKERS = {
  DOS_PICKER: 'appointPicker',
  DOB_PICKER: 'datePicker',
  GENDER_PICKER: 'genderPicker',
  MRN_INPUT: 'mrnInput'
}

export const FEATURE_FLAG = {
  SUKI_FFBE_USE_IMO_2022_Q4: 'SUKI_FFBE_USE_IMO_2022_Q4'
}

export const LOADING = 'loading'
export const MODAL_CONTENT = 'That\'s this patient\'s most recent appointment, and it does not yet have a note.'
export const MODAL_ADDITIONAL_CONTENT = 'You can change the date of service by clicking it on the note.'
